import * as React from 'react'
import { Text, View } from 'react-native'
import { FontAwesomeIcon } from '@purposity/icons'
import * as Colors from '@themes/Colors'
import { ProgressBar } from '../components/ProgressBar'
import { useGoalValue } from '../hooks/useGoals'
import styles from './styles'

export function MetricCard() {
  const goal = useGoalValue()

  return (
    <View style={styles.innerCardActive}>
      <View style={styles.topRow}>
        {goal ? (
          <View style={[styles.row, { alignItems: 'flex-end' }]}>
            <Text style={styles.goalNumber}>{goal.currentValue}</Text>
            <Text style={styles.labelActive}>
              {`/${goal.targetValue} needs this ${goal.period.noun}`}
            </Text>
          </View>
        ) : null}

        <Text style={{ fontSize: 24 }}>
          <FontAwesomeIcon
            icon={{ prefix: 'fal', iconName: 'pencil' }}
            color={Colors.dotGray}
          />
        </Text>
      </View>
      {goal ? (
        <ProgressBar
          targetValue={goal.targetValue}
          currentValue={goal.currentValue}
        />
      ) : null}
    </View>
  )
}
